import React from 'react';
import { useTranslation } from 'react-i18next';
import { displayErrorMessage, displayKudzuplusErrorMessage } from '../../../utils';
import { useSelector } from 'react-redux';
import { selectIsTransferMoneyFeatureEnabled } from '../../../Redux/selectors';

// Static mapping so Tailwind's class scanner can detect these classes at build time
const ROW_ITEMS_PER_LINE_CLASSES = {
    1: 'sm:grid-cols-1',
    2: 'sm:grid-cols-2',
    3: 'sm:grid-cols-3',
    4: 'sm:grid-cols-4',
    5: 'sm:grid-cols-5',
    6: 'sm:grid-cols-6',
};



const CustomRadioButtonGroup = ({ isTitle = true, title, name = 'frequency', options = [], selectedValue, onSelect, error, isRow = 'default', isRowOnMobileSrn = false, isTextBelow = false, isDisabled = false, rowItemsPerLine = null }) => {
    const { t } = useTranslation();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);
    const kudzu = !signUpkudzuPlusTrue && kudzuPlusTrue ? false : kudzuPlusTrue
    const enabledOptions = options.filter(option => !option.disabled)
    const evenArrayOptions = enabledOptions.filter((option, index) => index % 2 === 0)
    const oddArrayOptions = enabledOptions.filter((option, index) => index % 2 !== 0)
    const groupId = `${name}-group-label`;
    const errorId = `${name}-error`;
    const isTransferMoneyFeatureEnabled = useSelector(selectIsTransferMoneyFeatureEnabled);
    const rowOptionsContainerClass = isTransferMoneyFeatureEnabled
        ? `grid grid-cols-1 ${ROW_ITEMS_PER_LINE_CLASSES[rowItemsPerLine] || 'sm:grid-cols-3'} gap-y-4 gap-x-2 w-full mt-1`
        : 'flex flex-col sm:flex-row gap-10 sm:gap-2 w-full mt-3 justify-between';

    const isChecked = (option) => {
        return selectedValue === (option.displayText || option.DisplayText) || option?.isSelected;
    };

    const RadioOption = ({ option, index, textBelowKey }) => (
        <label className={`flex items-center gap-4 cursor-pointer mb-7 ${isDisabled ? 'pointer-events-none' : ''}`}>
            <input
                type="radio"
                id={`${name}-${option.displayText || option.DisplayText}`}
                name={name}
                value={option.displayText || option.DisplayText}
                className="hidden peer"
                checked={isChecked(option)}
                onChange={() => !isDisabled && onSelect(option, index)}
                disabled={isDisabled}
            />
            <div className={`w-[22px] h-[22px] rounded-full border-2 ${kudzuPlusTrue ? 'border-[#A0A5B3]' : 'border-[#2965FB]'} relative
                peer-checked:border-[#2965FB]
                peer-checked:after:content-['']
                peer-checked:after:w-[10px]
                peer-checked:after:h-[10px]
                peer-checked:after:bg-[#2965FB]
                peer-checked:after:rounded-full
                peer-checked:after:absolute
                peer-checked:after:top-1/2
                peer-checked:after:left-1/2
                peer-checked:after:-translate-x-1/2
                peer-checked:after:-translate-y-1/2`}>
            </div>
            <div className='flex flex-col'>
                <span className='font-hanken-grotesk font-[600] sm:font-[700] lg:text-[16px] md:text-[16px] sm:text-[11px] text-[14px] leading-[20px]
                    sm:leading-[20px] md:leading-[24px] text-[var(--modal-text-heading-clr)]'>
                    {option.label || option.displayText || option.DisplayText}
                </span>
                {isTextBelow && textBelowKey && (
                    <p className='font-hanken-grotesk font-[500]
                        leading-[20px] sm:leading-[20px] lg:text-[14px] md:text-[13px] sm:text-[13px] text-[14px]
                        md:leading-[22px] text-[var(--addSavings-percent-color)] md:w-[201px] sm:w-[155px] w-[201px] mt-4'>
                        {t(textBelowKey)}
                    </p>
                )}
            </div>
        </label>
    );

    return (
        <>
           

            {isRow === 'default' &&

                <div className='w-full flex flex-col' role="radiogroup" aria-labelledby={isTitle ? groupId : undefined} aria-label={!isTitle && title ? title : undefined} aria-describedby={error ? errorId : undefined}>

                    {isTitle &&
                        <p id={groupId} className={`font-hanken-grotesk font-[700] sm:font-[600]
                        leading-[12px] lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px]
                         sm:leading-[9px] md:leading-[13px]
                        text-[var(--input-text-title)]  uppercase tracking-[2px] md:pb-6 pb-5`}>
                            {title?.toLocaleUpperCase() || ''}</p>
                    }
                    <div className={`flex ${isRowOnMobileSrn ? 'flex-col sm:flex-row' : 'flex-row'} w-full justify-between`}>
                        <div className={`${isRowOnMobileSrn ? 'w-full' : 'w-[50%]'}`}>
                            {oddArrayOptions.reverse().map((option, index) => (
                                <div key={option.displayText || option.DisplayText} className='flex flex-col mb-5 sm:mb-0 w-full mt-3'>
                                    <RadioOption option={option} index={index} textBelowKey="percent_based_text" />
                                </div>
                            ))}
                        </div>
                        <div className={`${isRowOnMobileSrn ? 'w-full' : 'w-[50%]'}`}>
                            {evenArrayOptions.map((option, index) => (
                                <div key={option.displayText || option.DisplayText} className='flex flex-col w-full mt-3'>
                                    <RadioOption option={option} index={index} textBelowKey="amount_based_text" />
                                </div>
                            ))}
                        </div>
                    </div>


                    
                    <div id={errorId} className='mt-[10px] w-full' role="alert" aria-live="polite">
                        {error && (kudzuPlusTrue ? displayKudzuplusErrorMessage(error) : displayErrorMessage(error))}
                    </div>
                </div>
            }
            {isRow === 'row' &&

                <div className='w-full flex flex-col' role="radiogroup" aria-labelledby={isTitle ? groupId : undefined} aria-label={!isTitle && title ? title : undefined} aria-describedby={error ? errorId : undefined}>

                    {isTitle &&
                        <p id={groupId} className={` font-hanken-grotesk font-[700] sm:font-[600]
                         leading-[12px] lg:text-[13px] md:text-[12px] sm:text-[9px] text-[13px]
                          sm:leading-[9px]
                         md:leading-[13px] text-[var(--input-text-title)] uppercase tracking-[2px]
                         md:pb-6 pb-5`}>{title?.toLocaleUpperCase() || ''}</p>
                    }

                    <div className='flex flex-row w-full justify-between'>
                        <div className='w-full'>
                            <div className={rowOptionsContainerClass}>
                                    {options.filter(option => !option.disabled).map((option, index) => (
                                        <label key={option.displayText || option.DisplayText} className={`flex items-center gap-4 cursor-pointer ${isDisabled ? 'pointer-events-none' : ''}`}>
                                            <input
                                                type="radio"
                                                id={`${name}-${option.displayText || option.DisplayText}`}
                                                name={name}
                                                value={option.displayText || option.DisplayText}
                                                className="hidden peer"
                                                checked={isChecked(option)}
                                                onChange={() => !isDisabled && onSelect(option, index)}
                                                disabled={isDisabled}
                                            />
                                            <div className={`w-[22px] h-[22px] rounded-full border-2 ${kudzuPlusTrue ? 'border-[#A0A5B3]' : 'border-[#2965FB]'} relative
                                            peer-checked:border-[#2965FB]
                                            peer-checked:after:content-['']
                                            peer-checked:after:w-[10px]
                                            peer-checked:after:h-[10px]
                                            peer-checked:after:bg-[#2965FB]
                                            peer-checked:after:rounded-full
                                            peer-checked:after:absolute
                                            peer-checked:after:top-1/2
                                            peer-checked:after:left-1/2
                                            peer-checked:after:-translate-x-1/2
                                            peer-checked:after:-translate-y-1/2`}>
                                            </div>
                                            <span className='font-hanken-grotesk font-[600] sm:font-[700] lg:text-[16px] md:text-[16px] sm:text-[11px] text-[14px] leading-[20px]
                                            sm:leading-[20px] md:leading-[24px] text-[var(--freq-data-clr)]'>
                                                {option.displayText || option.DisplayText}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>


                    <div id={errorId} className='mt-[10px] w-full' role="alert" aria-live="polite">
                        {error && displayErrorMessage(error)}
                    </div>
                </div>
            }

        </>

    );
};

export default  CustomRadioButtonGroup;